export default __webpack_public_path__ + "static/media/strasbourg7.03ab1f45.jpg";